export enum QuestionState {
    NOT_ANSWERED = "NOT_ANSWERED",
    ANSWERED = "ANSWERED",
}